import { Grid, TextField } from "@mui/material";
import React from "react";
import GoogleAddressSelect from "../../carecoordinator/patient/GoogleAddressSelect";
import OfficeMultiSelect from "../../carecoordinator/patient/OfficeMultiSelect";

const AddEditTeamForm = ({
  teamDetails,
  setTeamDetails,
  errors,
  label,
  isOfficesAllowed,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTeamDetails((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={12} item>
          <TextField
            required
            fullWidth
            value={teamDetails?.name}
            name="name"
            label={`${label} Name`}
            variant="outlined"
            error={errors?.name}
            helperText={errors?.name}
            onChange={handleChange}
          />
        </Grid>
        {isOfficesAllowed && (
          <Grid xs={12} item>
            <OfficeMultiSelect
              data={teamDetails}
              setData={setTeamDetails}
              error={errors}
              required={true}
              isMultiSelect={false}
            />
          </Grid>
        )}
        <Grid xs={12} item>
          <TextField
            fullWidth
            label="Medicare Provider Number"
            name="medicareProviderNumber"
            value={teamDetails?.medicareProviderNumber}
            variant="outlined"
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            label="National Provider Identifier"
            name="nationalProviderIdentifier"
            value={teamDetails?.nationalProviderIdentifier}
            variant="outlined"
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <GoogleAddressSelect
            address={teamDetails?.address}
            setData={setTeamDetails}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            value={teamDetails?.notes}
            multiline
            rows={2}
            name="notes"
            label="Notes"
            variant="outlined"
            onChange={handleChange}
            sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AddEditTeamForm;
